import type { ResourceCost } from './types';

export type ResearchEffect =
  | 'atk_flat'      // +N ATK permanent
  | 'def_flat'      // +N DEF permanent
  | 'hp_flat'       // +N Max HP permanent
  | 'xp_pct'        // +N% XP gain
  | 'click_credits' // +N% credits per click
  | 'loot_pct';     // +N% loot drop chance

export interface ResearchNode {
  id: string;
  nameKey: string;
  descKey: string;
  maxLevel: number;
  effect: ResearchEffect;
  valuePerLevel: number;
  costPerLevel: (level: number) => ResourceCost;
}

export const RESEARCH_NODES: ResearchNode[] = [
  {
    id: 'combat_overdrive',
    nameKey: 'research.combat_overdrive',
    descKey: 'research.combat_overdrive_desc',
    maxLevel: 5,
    effect: 'atk_flat',
    valuePerLevel: 3,
    costPerLevel: (l) => ({ credits: Math.round(500 * Math.pow(2, l)), energy_cell: (l + 1) * 3 }),
  },
  {
    id: 'neural_shield',
    nameKey: 'research.neural_shield',
    descKey: 'research.neural_shield_desc',
    maxLevel: 5,
    effect: 'def_flat',
    valuePerLevel: 2,
    costPerLevel: (l) => ({ credits: Math.round(600 * Math.pow(2, l)), nano_chip: (l + 1) * 2 }),
  },
  {
    id: 'bio_enhancement',
    nameKey: 'research.bio_enhancement',
    descKey: 'research.bio_enhancement_desc',
    maxLevel: 5,
    effect: 'hp_flat',
    valuePerLevel: 15,
    costPerLevel: (l) => ({ credits: Math.round(400 * Math.pow(2, l)), scrap: (l + 1) * 20 }),
  },
  {
    id: 'data_compression',
    nameKey: 'research.data_compression',
    descKey: 'research.data_compression_desc',
    maxLevel: 3,
    effect: 'xp_pct',
    valuePerLevel: 10,
    costPerLevel: (l) => ({ credits: Math.round(2000 * Math.pow(3, l)), data_track: (l + 1) * 2 }),
  },
  {
    id: 'credit_siphon',
    nameKey: 'research.credit_siphon',
    descKey: 'research.credit_siphon_desc',
    maxLevel: 3,
    effect: 'click_credits',
    valuePerLevel: 15,
    costPerLevel: (l) => ({ credits: Math.round(1000 * Math.pow(2, l)) }),
  },
  {
    id: 'quantum_harvest',
    nameKey: 'research.quantum_harvest',
    descKey: 'research.quantum_harvest_desc',
    maxLevel: 3,
    effect: 'loot_pct',
    valuePerLevel: 5,
    costPerLevel: (l) => ({ credits: Math.round(5000 * Math.pow(3, l)), hyper_processor_5: l + 1 }),
  },
];

export function researchBonus(research: Record<string, number>, effect: ResearchEffect): number {
  return RESEARCH_NODES
    .filter((n) => n.effect === effect)
    .reduce((sum, n) => sum + (research[n.id] ?? 0) * n.valuePerLevel, 0);
}
